export function isElectron() {
  return typeof window !== 'undefined' && window.arkitectDesktop !== undefined;
}

export function isBrowser() {
  return !isElectron();
}
